import Rutas from "./routes/Rutas";
import FirebaseContext from "./context/FirebaseContext";
import "../src/css/main.css"

function App() {
  return (
    <FirebaseContext>
      <Rutas />
    </FirebaseContext>
  );
}

export default App;
